import React from 'react';
import {Container, Icon, IconContainer, LogoIconContainer, LogoIcon} from "./left-sidebar.styles";
import {logout, setOfflineUser} from "../../helpers/auth";
import {auth} from "../../services/firebase";
import {NavLink} from "react-router-dom";

const LeftSidebar = () => {

    const logoutHandler = async () => {
        await setOfflineUser(auth().currentUser);
        await logout()
    }

    return (
        <Container className='d-flex flex-column align-items-center'>
            <LogoIconContainer className='d-none d-xl-block'>
                <LogoIcon className="fas fa-comments"/>
            </LogoIconContainer>
            <IconContainer
                className="d-flex flex-xl-column justify-content-between justify-content-xl-center align-items-center w-100">
                <NavLink to='/group-chat' className='links mb-xl-5' activeClassName='active-link'>
                    <Icon className="far fa-comments"/>
                </NavLink>
                <NavLink to='/private-chat' className='links mb-xl-5' activeClassName='active-link'>
                    <Icon className="far fa-comment"/>
                </NavLink>
                <NavLink to='/friends' className='links mb-xl-5' activeClassName='active-link'>
                    <Icon className="far fa-user-circle"/>
                </NavLink>
                <button className="simple-btn mb-xl-5" onClick={logoutHandler}>
                    <Icon className="fas fa-sign-out-alt"/>
                </button>
            </IconContainer>
        </Container>
    );
};

export default LeftSidebar;
